"use client";

import { m } from "motion/react";
import type { ReactNode } from "react";
import { duration, easing } from "@/lib/animation/tokens";

/**
 * Route-change transition. `template.tsx` re-mounts on every pathname
 * change (unlike `layout.tsx`, which persists), so wrapping it in a
 * motion.div with `animate` is enough to fade each new page in.
 *
 * Pathname-only — `template.tsx` doesn't re-mount on hash or query
 * changes, so in-page anchor jumps don't trigger the transition.
 */
export default function Template({ children }: { children: ReactNode }) {
  return (
    <m.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: duration.sm, ease: easing.out }}
    >
      {children}
    </m.div>
  );
}
